export const normalizeEip155ChainId = (chainId: unknown): number | undefined => {
  if (typeof chainId === 'number') {
    return Number.isSafeInteger(chainId) ? chainId : undefined
  }

  if (typeof chainId === 'bigint') {
    return chainId <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(chainId) : undefined
  }

  if (typeof chainId !== 'string') {
    return undefined
  }

  const numericPart = chainId.includes(':')
    ? chainId.split(':').at(-1)
    : chainId

  if (!numericPart) {
    return undefined
  }

  const normalized = Number(numericPart)

  return Number.isSafeInteger(normalized) ? normalized : undefined
}
